// src/services/sceneService.js
import { API } from "../config/api"

// GET /api/movies/:id/scenes  -> { scenes: [...] }
export async function listScenes(movieId) {
    const { data } = await API.get(`/movies/${movieId}/scenes`)
    return Array.isArray(data?.scenes) ? data.scenes : []
}

// POST -> { scene: {...} }
export async function createScene(movieId, payload) {
    const { data } = await API.post(`/movies/${movieId}/scenes`, payload)
    return data.scene
}

export async function updateScene(movieId, sceneId, patch) {
    const { data } = await API.put(`/movies/${movieId}/scenes/${sceneId}`, patch)
    return data.scene
}

export async function deleteScene(movieId, sceneId) {
    const { data } = await API.delete(`/movies/${movieId}/scenes/${sceneId}`)
    return data
}